const lazyImages = document.querySelectorAll<HTMLImageElement>('img[loading="lazy"]');

const loaded = (image: HTMLImageElement) => {
  image.classList.add('loaded');
};

export function initImage(image: HTMLImageElement) {
  if (image.complete) {
    loaded(image);
    return;
  }
  image.addEventListener('load', () => loaded(image));
}

lazyImages.forEach(image => {
  initImage(image);
});
